import z from "zod";

export const OAuthInitResponseSchema = z.object({
  url: z.string(),
});
export type OAuthInitResponse = z.infer<typeof OAuthInitResponseSchema>;
